import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import StoryUpload from './StoryUpload';
import StoryViewer from './StoryViewer';
import '../styles/StoriesBox.css';

const StoriesBox = () => {
  const { user } = useSelector(state => state.auth);
  const [stories, setStories] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [showViewer, setShowViewer] = useState(false);
  const [viewerInitialIndex, setViewerInitialIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchStories = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/stories/feed`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setStories(response.data || []);
      } catch (err) {
        console.error('Error fetching stories:', err);
        setStories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStories();
  }, [token]);

  const handleCreateStory = (newStory) => {
    setStories([newStory, ...stories]);
    setShowUpload(false);
  };

  const handleStoryClick = (index) => {
    setViewerInitialIndex(index);
    setShowViewer(true);
  };

  if (loading) {
    return null;
  }

  // Group stories by user and get latest one per user
  const storiesByUser = {};
  stories.forEach(story => {
    const authorId = story.author._id;
    if (!storiesByUser[authorId]) {
      storiesByUser[authorId] = story;
    }
  });

  const displayStories = Object.values(storiesByUser);

  return (
    <>
      {(displayStories.length > 0 || true) && (
        <div className="stories-box">
          <div className="story-item add-story" onClick={() => setShowUpload(true)}>
            <div className="story-avatar">
              <div className="story-avatar-content">
                {user?.profilePicture ? (
                  <img src={`http://localhost:5000${user.profilePicture}`} alt="Your avatar" />
                ) : (
                  <span>{user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}</span>
                )}
              </div>
              <span className="add-icon">+</span>
            </div>
            <div className="story-label">Ваша история</div>
          </div>

          {displayStories.map((story, index) => {
            const isViewed = story.views.some(v => v._id === user?._id || v === user?._id);
            return (
              <div
                key={story._id}
                className={`story-item ${isViewed ? 'viewed' : 'unviewed'}`}
                onClick={() => handleStoryClick(index + 1)} // +1 because first item is "add story"
              >
                <div className="story-avatar">
                  <div className="story-avatar-content">
                    {story.author.profilePicture ? (
                      <img src={`http://localhost:5000${story.author.profilePicture}`} alt={story.author.username} />
                    ) : (
                      <span>{story.author.firstName?.charAt(0)}{story.author.lastName?.charAt(0)}</span>
                    )}
                  </div>
                </div>
                <div className="story-label">
                  {story.author.firstName}
                </div>
                {!isViewed && <div className="unviewed-indicator"></div>}
              </div>
            );
          })}
        </div>
      )}

      {showUpload && (
        <StoryUpload
          onStoryCreated={handleCreateStory}
          onCancel={() => setShowUpload(false)}
        />
      )}

      {showViewer && (
        <StoryViewer
          stories={displayStories}
          initialStoryIndex={Math.max(0, viewerInitialIndex - 1)}
          onClose={() => setShowViewer(false)}
        />
      )}
    </>
  );
};

export default StoriesBox;
